import Car from "@src/interfaces/carDetails.interface";

export const getProductTitle = (car: Car): string => {
    const { title, year, mileage, color, transmission } = car;

    const result = [title];

    if (year) result.push(`${year}`);
    if (mileage) result.push(`${mileage} км`);
    if (color) result.push(color);
    if (transmission) result.push(transmission);

    return result.join(", ");
};